// map of staffId → { paid, paidAt, unPaidAt, ... }
export const payoutStatusMapSelector = (state) => {
  const records = state.payoutStatusReducer?.records || [];
  return records.reduce((acc, r) => {
    acc[r.staff] = r;
    return acc;
  }, {});
};
